import { GEO_CURRENCY_MAP } from './geoCurrency';

const TERRITORY_TIERS = ['pan', 'cop', 'cad', 'aud', 'zar'] as const;

export type TerritoryTier = (typeof TERRITORY_TIERS)[number];

export const getTerritoryTier = (userLocation: string | null | undefined): TerritoryTier | null => {
  if (!userLocation) return null;
  const tier = GEO_CURRENCY_MAP[userLocation];
  return TERRITORY_TIERS.find((territory) => territory === tier) ?? null;
};
